import React, { useEffect, useRef } from 'react'
import { Link } from 'gatsby'
import { sendGAEvent } from '@utils/analytics'
import { GA_EVENTS } from '@utils/analytics/constants'

const LinkButton = ({ 
  label,
  icon = null,
  iconPosition = 'end',
  iconGap = 'gap-x-3',
  onClick,
  to = "/",
  className = null,
  color = null,
  defaultSelected=false,
  ariaLabel = '',
  underline = false, 
  underlineOnHover = false,
 }) => {
  const buttonRef = useRef(null)

  useEffect(() => {
    if(defaultSelected && buttonRef.current)
      buttonRef.current.focus()
  }, [defaultSelected])

  const handleOnClick = () => {
	sendGAEvent(GA_EVENTS.NAVIGATION_CLICK, {button_text: `${label}`})
	if(onClick) onClick()
  }

  return (
    <Link 
      className={`soft-button ${color && 'text-[#' + color + ']'} ${className && className} w-fit ${underlineOnHover && 'hover:underline hover:underline-offset-4'}`}
      onClick={handleOnClick}
      to={to}
      ref={buttonRef}
      aria-label={ariaLabel}
      >
      <span className={`inline-flex ${iconGap} items-center ${underline && 'underline underline-offset-4'}`}>
        { iconPosition === 'start' && icon }
        { label }
        { iconPosition === 'end' && icon }
      </span>
    </Link>
  )
}

export default LinkButton